/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/*
this page used to Movements tab load the ANPR reads data
*/
// Due to thirdParty grid component
// System defined variables
import React from 'react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
// Custom defined variables
import Grid from '../../../../components/base/grid/Grid'
import GridPageSize from '../../../../components/custom/gridPageSize/GridPageSize'
import './ManualReviewMovements.css'
import useManualReviewMovementsData from './hooks/useManualReviewMovementsData'
import useManualReviewMovementsGrid from './hooks/useManualReviewMovementsGrid'

const ManualReviewMovements = ({ observationDetails }) => {
  const { gridRef, gridApi, onGridReady, columns, gridRowData } =
    useManualReviewMovementsGrid()
  const { perPageSize, onChangeHandler, onRefreshClickHandler } =
    useManualReviewMovementsData({
      gridApi,
      gridRef,
      observationDetails,
    })

  return (
    <div className="ManualReviewMovements">
      <div className="headerSection">
        <div className="divPagesize">
          <GridPageSize
            onPageSizeHandler={onChangeHandler}
            isRefreshEnabled={true}
            onRefreshClickHandler={onRefreshClickHandler}
            timezoneType="case"
          ></GridPageSize>
        </div>
      </div>

      <Grid
        dataSource={gridRowData}
        columnDefs={columns}
        listviewergridref={gridRef}
        rowModelType={'infinite'}
        onGridReady={onGridReady}
        pagination={true}
        paginationPageSize={perPageSize}
        cacheBlockSize={perPageSize}
        rowHeight={50}
        defaultColDef={{ flex: 1 }}
        overlayNoRowsTemplateText={'No movement history available'}
      ></Grid>
    </div>
  )
}

export default ManualReviewMovements
